export default "__VITE_ASSET__xvUOmPIT__"